import Home from "./components/Home";
import {BrowserRouter as Router,Switch,Route,Link} from "react-router-dom";
import Header from "./components/Header";
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from "./components/Login/Login";
import { useEffect,useState } from "react";
import RegisterPage from "./components/registration/Registration";
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { setAnalyticsDetails,selectLayerDataSet } from "./features/layers/overlaylayerslice";

const App = () => {
  const dispatch = useDispatch();
  const state = useSelector(selectLayerDataSet);


  return (
    <>   
    <div >
   <Router>

      <Header/>
      <Switch>
        <Route exact path="/dashboard" component={Home}/>
      </Switch>
      </Router>
    </div>
    </>
  );
};

export default App;
